module.exports = __webpack_public_path__ + "media/application/images/2018/consumer-peoples-choice-logo-b67a42f3b4e25eef4443e3ecbbabab81.png";